export const DEFAULT_FORMATS = 'zip';

// What an EHR export upload accepts. Vendors hand data over in very different
// shapes — zipped CCD bundles, CSV/TSV collections (DrChrono, Jane, Practice
// Fusion), spreadsheets, vCard contact dumps, a SQL Server .bak (eCW) — and the
// backend already routes anything that isn't a zip straight into the batch's
// data/ prefix, so restricting the picker to .zip only made people re-zip files.
export const IMPORT_FILE_FORMATS =
  '.zip,.csv,.tsv,.txt,.xlsx,.xls,.xml,.ccd,.ccda,.cda,.vcf,.json,.bak';

// Picker list icon by extension; anything unlisted gets the generic file icon.
export const IMPORT_FILE_ICONS = {
  zip: 'file-zip',
  csv: 'file-csv',
  tsv: 'file-csv',
  txt: 'file-txt',
  xlsx: 'file-xlsx',
  xls: 'file-xls',
  xml: 'file-xml',
  ccd: 'file-xml',
  ccda: 'file-xml',
  cda: 'file-xml',
  json: 'file-json'
};

export const iconForFile = (name = '') => {
  const ext = String(name).toLowerCase().split('.').pop();
  return IMPORT_FILE_ICONS[ext] || 'file-default';
};
export const DEFAULT_TITLE = 'Choose a file or drag & drop it here';

export const DOCUMENT_TYPES = {
  'application/pdf': 'file-pdf',
  'image/jpeg': 'file-jpg',
  'image/png': 'file-png'
};

export const STATUSES = {
  uploading: 'Uploading...',
  uploaded: 'Completed',
  failed: 'Failed'
};

export const ICON_TYPES = {
  uploading: 'loader',
  uploaded: 'checkmark-circle',
  failed: 'new-info'
};

export const TRY_AGAIN_LABEL = 'Try again';

export const STEPS = {
  PRACTICE: 0,
  VENDOR: 1,
  FILES: 2,
  UPLOAD: 3,
  PROCCESS: 4
};

export const FILE_UPLOAD_STATUS = {
  INITIATED: 0,
  UPLOADING: 1,
  UPLOADED: 2,
  ERROR: 3
};

export const CHUNK_SIZE = 5 * 1024 * 1024;

export const initialBreadcrumbs = [
  { title: 'Select practice', active: true, view: STEPS.PRACTICE },
  { title: 'Select vendor', view: STEPS.VENDOR },
  { title: 'Select files', view: STEPS.FILES },
  { title: 'Upload files', view: STEPS.UPLOAD },
  { title: 'Process files', view: STEPS.PROCCESS }
];
